import React, { useState, useEffect } from 'react';
import CustomTextField from "../../../common/InputField/Input";
import { FaMinus } from "react-icons/fa";
import { IoMdAdd } from "react-icons/io";
import { FaTimes } from "react-icons/fa";
import { ConstructionOutlined } from '@mui/icons-material';

const DayWiseSetting = ({
  localHotelDetailsState,
  setLocalHotelDetailsState,
  pa,
  setPa
}) => {
   const [dayMap, setDayMap] = useState(localHotelDetailsState?.priceAdjustment?.dayWiseDiscountMap || {});

  // Initialize rows to an empty array
  const [rows, setRows] = useState([]);

  // Whenever dayMap changes, rebuild & sort your rows
  useEffect(() => {
    const newRows = Object.entries(dayMap)
      .map(([days, pct]) => ({ days, pct }))
      .sort((a, b) => Number(a.days) - Number(b.days));
    setRows(newRows);
  }, [dayMap]);

  const updateRows = newRows => {
    setRows(newRows);
    // convert back to map
    const dayWiseDiscountMap = {};
    newRows.forEach(r => {
        dayWiseDiscountMap[r.days] = r.pct;
      
    });
    setLocalHotelDetailsState({
      ...localHotelDetailsState,
      priceAdjustment: {
        ...pa,
        dayWiseDiscountMap
      }
    });
    setPa({...pa, dayWiseDiscountMap});
    setDayMap(dayWiseDiscountMap);
  };

  const addRow = () => updateRows([...rows, { days: "", pct: "" }]);
  const removeRow = idx => updateRows(rows.filter((_, i) => i !== idx));

  return (<div className="mt-8">
    <div className="font-body text-[18px] mb-4">
      Day Wise Discount
    </div>
    {rows.map((row, i) => (
      <div key={i} className="flex items-center gap-4 mb-2">
        <CustomTextField
          placeholder="Days before"
          value={row.days}
          onChange={v => {
            const newRows = [...rows];
            newRows[i].days = v;
            updateRows(newRows);
          }}
          type="number"
        />
        <CustomTextField
          placeholder="Discount %"
          value={row.pct}
          onChange={v => {
            const newRows = [...rows];
            newRows[i].pct = v;
            updateRows(newRows);
          }}
          type="number"
        />
        <button
          className="
    flex items-center justify-center
    w-8 h-8
    bg-surface
    text-red-500
    hover:bg-red-50
    transition
  "
          onClick={() => removeRow(i)}
          aria-label="Remove Day Discount"
        >
          <FaTimes />
        </button>

      </div>
    ))}
    <button
      className="
    flex items-center gap-1 mt-2
    bg-surface
    text-primary
    border border-primary
    px-3 py-2
    rounded-[6px]
    font-body font-[500] text-[14px]
    hover:bg-primary-light
    transition
  "
      onClick={addRow}
    >
      <IoMdAdd /> <span>Add Day Discount</span>
    </button>
  </div>)
}

export default DayWiseSetting;